import PropTypes from 'prop-types';
import { Alert, AlertTitle, Container } from '@mui/material';
import useAuth from 'hooks/useAuth';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.oneOf(['PARTNER', 'OPERATOR', 'REPORTER', 'SUPER_ADMIN']),
  children: PropTypes.node
};

const useCurrentRole = () => {
  const { user } = useAuth();
  return user?.authorities[0];
};

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const currentRole = useCurrentRole();

  if (!accessibleRoles.includes(currentRole)) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
